/* eslint-disable @typescript-eslint/no-unused-vars */
import { Grid, MenuItem } from '@material-ui/core';
import {
  getBusinessPartners,
  getDegreeLevel,
  getGoals,
  getJobs,
  getJobsDomains,
  getSchoolsPartners,
  getTrainingDomains,
  getSchoolFormations,
  getDegree,
  getTrainingType,
} from '@webapps/business';
import {
  Button,
  FormikAutocomplete,
  FormikTextField,
  useAuth,
  useQuery,
  TextField,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

const FiltersClasses = ({ formik = {} }) => {
  const {
    classes,
    css,
    theme: { spacing },
  } = useStyles(styles);
  const { idUser, profile } = useAuth();
  const [searchString, setSearchString] = useState('');
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [training, setTraining] = useState('');
  const [degree, setDegree] = useState('');
  const [trainingType, setTrainingType] = useState('');

  const { data: { content: formations = [] } = {} } = useQuery(
    getSchoolFormations,
    {
      key: ['formations', page + idUser + keyword],
      variables: {
        id: idUser,
        page: page - 1,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const {
    data: { content: partnersSchool = [] } = {},
    isLoading: isLoadingGetMyBusiness,
  } = useQuery(getSchoolsPartners, {
    key: ['schoolsPartners', idUser],
    variables: {
      id: idUser,
      type: 'accepted',
      page: 0,
      size: 2000,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const {
    data: { content: partnersBusiness = [] } = {},
    isLoading: isLoadingGetMySchools,
  } = useQuery(getBusinessPartners, {
    key: ['businessPartners', idUser],
    variables: {
      id: idUser,
      type: 'accepted',
      page: 0,
      size: 2000,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });


  const { data: degrees = [] } = useQuery(getDegree, {
    key: 'degreeMap',
  });

  const { data: AllDegreeLevels = [], isLoading: degreeLevelLoading } =
    useQuery(getDegreeLevel, {
      key: 'levels',
    });

  const { data: goals = [], isLoading: isLoadingGoals } = useQuery(getGoals, {
    key: 'allGoals',
  });

  const getLabel = (label) => {
    switch (label) {
      case 'Trouver un stage':
        return 'En recherche de stage';
      case 'Trouver une alternance':
        return "En recherche d'une alternance";
      case 'Trouver une formation':
        return "En recherche d'une formation";
      case 'Trouver une formation et un stage':
        return "En recherche d'une formation et d'un stage";
      case 'Trouver une formation et une alternance':
        return "En recherche d'une formation et d'une alternance";
      default:
        return 'En recherche de stage';
    }
  };

  const {
    data: { content: trainingDomains = [] } = {},
    isLoading: trainingDomainsLoading,
  } = useQuery(getTrainingDomains, {
    key: 'trainingDomains',
  });

  const contractLength = ['1', '2', '3', '4', '6', '12', '24'];

  const { data: { content: jobs = [] } = {} } = useQuery(getJobs, {
    key: ['jobs', searchString],
    variables: { keyword: searchString || '' },
  });

  const { data: jobDomains = [] } = useQuery(getJobsDomains, {
    key: 'jobsDomain',
  });

  const { data: trainingTypes = [] } = useQuery(getTrainingType, {
    key: 'trainingTypeMap',
  });

  const resetFilter = () => {
    formik.resetForm();
    formik.handleSubmit();
  };

  const searchKeyword = (e) => {
    setKeyword(e.target.value);
    setPage(1);
  };

  const searchTraining = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all' ? setTraining('') : setTraining(e.target.value);
      setPage(1);
    }
  };

  const searchDegree = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all' ? setDegree('') : setDegree(e.target.value);
      setPage(1);
    }
  };

  const searchTrainingType = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all'
        ? setTrainingType('')
        : setTrainingType(e.target.value);
      setPage(1);
    }
  };

  const TYPES_PROFIL = [
    {
      label: 'Oui',
      value: true,
    },
    {
      label: 'Non',
      value: false,
    },
    {
      label: 'Tous',
      value: 'all',
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid className={classes.grid} item xs={12}>
        <FormikTextField
          formik={formik}
          fullWidth
          label="Offre de formation"
          onChange={(e) => searchTraining(e)}
          select
          variant="outlined"
          borderRadius={400}
          value={formik.values.training}
          name="training"
        >
          <MenuItem value="all">Toutes les formations</MenuItem>
          {formations.map(({ id, label }, index) => (
            <MenuItem key={index} value={id}>
              {label}
            </MenuItem>
          ))}
        </FormikTextField>
      </Grid>
      <Grid className={classes.grid} item xs={12}>
        <FormikTextField
          formik={formik}
          fullWidth
          label="Niveau de diplôme"
          name="degree"
          // value={formik.values.degree}
          // onChange={(e) => searchDegree(e)}
          borderRadius={400}
          select
        >
          <MenuItem value="all" className={classes.menuItem}>
            Tous les niveaux
          </MenuItem>
          {degrees.map(({ id, label }, index) => (
            <MenuItem key={index} className={classes.menuItem} value={id}>
              {label}
            </MenuItem>
          ))}
        </FormikTextField>
      </Grid>
      <Grid className={classes.grid} item xs={12}>
        <FormikTextField
          formik={formik}
          value={formik.values.trainingType}
          fullWidth
          label="Type de formation"
          name="trainingType"
          onChange={(e) => searchTrainingType(e)}
          borderRadius={400}
          select
        >
          <MenuItem value="all" className={classes.menuItem}>
            Tous les types de formation
          </MenuItem>
          {trainingTypes.map(({ id, label }, index) => (
            <MenuItem key={index} className={classes.menuItem} value={id}>
              {label}
            </MenuItem>
          ))}
        </FormikTextField>
      </Grid>

      <Grid className={classes.grid} item xs={12}>
        <Button
          color="primary"
          fullWidth
          onClick={() => {
            formik.handleSubmit();
          }}
          variant="contained"
          className={css({ borderRadius: '400px' })}
        >
          <FormattedMessage id="btnSearch" />
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button
          className={css({ backgroundColor: 'white' })}
          color="primary"
          fullWidth
          onClick={resetFilter}
          variant="outlined"
        >
          Réinitialiser
        </Button>
      </Grid>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  grid: {
    marginBottom: '10px',
  },
});

FiltersClasses.propTypes = {
  formik: PropTypes.object,
};

export default FiltersClasses;
